import { createElement, PropTypes } from 'rlink-react';
import { Picture } from 'rlink-repos/content-components';

export default function History ({historyData}) {
  return (
    <article className="node node-history node-promoted view-mode-full layout-text">
      <div className="image">
        {historyData.mainImageFormats.src !== '' && (
          <Picture
            src={historyData.mainImageFormats.src}
            widths={historyData.mainImageFormats.widths}
            heights={historyData.mainImageFormats.heights}
            formats={historyData.mainImageFormats.formats} />
        )}
      </div>
      <div className="wrapper">
        <div className="row">
          <div className="title-block">
            <div className="field field-name-field-icon field-type-image field-label-hidden field-wrapper">
              {historyData.iconImageFormats.src !== '' && (
                <Picture
                  src={historyData.iconImageFormats.src}
                  widths={historyData.iconImageFormats.widths}
                  heights={historyData.iconImageFormats.heights}
                  formats={historyData.iconImageFormats.formats} />
              )}
            </div>
            <h2 className="node-title">
              <div className="field field-name-field-year field-type-datetime field-label-hidden field-wrapper">
                <span className="date-display-single">{historyData.year}</span>
              </div>
            </h2>
            <h4 className="noline">
              <div className="field field-name-field-subtitle field-type-text field-label-hidden field-wrapper">{historyData.title}</div>
            </h4>
          </div>
          <div className="ch">
            <div className="body field" dangerouslySetInnerHTML={{__html: historyData.description}} />
          </div>
        </div>
      </div>
    </article>
  );
}

History.propTypes = {
  historyData: PropTypes.shape({
    mainImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
    iconImageFormats: PropTypes.shape({
      src: PropTypes.string,
      widths: PropTypes.arrayOf(PropTypes.number),
      heights: PropTypes.arrayOf(PropTypes.number),
      formats: PropTypes.arrayOf(PropTypes.shape({
        contentType: PropTypes.string,
        fileExt: PropTypes.string,
      })),
    }),
    year: PropTypes.string,
    title: PropTypes.string,
    priority: PropTypes.number,
    description: PropTypes.string,
  }),
};



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/components/History/History.jsx